const Mn = require('backbone.marionette');
const EmptyItemTemplate = require('common/ui/template/empty-item.hbs');
const EmptyListItemTemplate = require('common/ui/template/empty-list-item.hbs');

module.exports = Mn.View.extend({
    isList: false,
    getTemplate: function() {
        if(this.getOption('isList')) {
            return EmptyListItemTemplate;
        } else {
            return EmptyItemTemplate;
        }
    },
    templateContext: function() {
        return {
            title: this.getOption('title')
        }
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/empty-item.js